/*
 * @Auther: 罗耀祖
 * @Date: 2022-02-14 14:27:35
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-04-08 11:40:35
 * @name: 工单管理-售后经理审批
 * @Description: 工单管理-售后经理审批
 * @FilePath: \project\src\module\issue\validator\qualityVerify.js
 * @Author: desktop
 */
export const validator = [
  {
    key: 'issue_id',
    description: '工单id',
    required: true,
    required_message: '工单id为必传项',
    match: (e) => {
      return '';
    }
  },
  {
    key: 'run_process_id',
    description: '流程id',
    required: true,
    required_message: '流程id为必传项',
    match: (e) => {
      return '';
    }
  },
  {
    key: 'remark',
    description: '审批建议',
    required: false,
    match: (e) => {
      return '';
    }
  },
  {
    key: 'cause_analysis',
    description: '不合格原因分析',
    required: false,
    match: (e) => {
      return '';
    }
  },
  {
    key: 'deal_notice',
    description: '处理意见',
    required: false,
    match: (e) => {
      return '';
    }
  },
  {
    key: 'quality_verify_res_url',
    description: '评审结果地址集合，以，间隔',
    required: false,
    match: (e) => {
      return '';
    },
    match_toast: true,
  },
  {
    key: 'department',
    description: '部门',
    required: false,
    match: (e) => {
      return '';
    },
    match_toast: true,
  },
]